import { TitleH3 } from "@/components/shared/public";
import BlogImage from "@/components/shared/public/blogs/BlogImage";
import { ComponentProps } from "react";

type StepContainerProps = ComponentProps<typeof BlogImage> &
  ComponentProps<typeof TitleH3> & {
    text: string;
    imageLeft?: boolean;
    imageFit?: "cover" | "contain";
  };

const StepContainer = ({ imageFit, ...props }: StepContainerProps) => {
  const imageRight = !props.imageLeft;
  const isCover = imageFit === "cover";

  return (
    <div
      className={`gs--blog-section__grid ${imageRight ? "gs--blog-section__grid--image-right" : ""} ${isCover ? "gs--blog-section__grid--cover" : ""}`}
    >
      <div className="gs--blog-section__col-image">
        <BlogImage
          className="gs--blog-section__image"
          src={props.src}
          alt={props.alt}
          sizes={props.sizes}
          unoptimized={props.unoptimized}
          width={props.width}
          height={props.height}
          objectFit={isCover ? "cover" : undefined}
        />
      </div>
      <div className="gs--blog-section__col-text">
        <TitleH3 title={props.title} />
        <p className="text-ring mt-3">{props.text}</p>
      </div>
    </div>
  );
};

export default StepContainer;
